<div class="error-header">
    <img class="error-image" src="../../../assets/svg/error_page_icon.svg">
    <h1 class="error-title">Oh no! Something went wrong.</h1>
    <span class="error-description">We’re experiencing some technical difficulties. You may refresh the page or try again later.</span>
</div>